import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { closeCustomModal, openCustomModal } from "../../../custom/modals";
import TravelLocationsReportModal from "./create-modal";

class TravelLocationsReportButton extends React.PureComponent {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick = () => {
        const modalObj = {
            id: "travel-locations-report-modal",
            modalSettings: {
                size: "md"
            },
            header: this.props.title,
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <TravelLocationsReportModal
                        handleClose={() => this.props.closeCustomModal(modalObj)}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render() {
        const {
            className,
            title
        } = this.props;

        return (
            <button
                className={className}
                onClick={this.handleClick}
            >
                {title}
            </button>
        );
    }
}

TravelLocationsReportButton.propTypes = {
    className: PropTypes.string,
    title: PropTypes.string,
};

const mapStateToDispatch = dispatch => ({
    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
});

export default connect(
    null,
    mapStateToDispatch
)(TravelLocationsReportButton);
